import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Login from './components/Login';
import MainApp from './components/MainApp';
import DashboardPage from './components/DashboardPage';
import ApprovalsPage from './components/ApprovalsPage';
import './utils/axiosConfig'; // Configuration globale d'Axios
import './styles/themes.css'; // Thèmes CSS
import './App.css';

// Composant qui gère l'affichage selon l'état d'auth
function AppContent() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '20px' }}>🔄</div>
        <div style={{ fontSize: '18px', color: '#666' }}>Chargement de l'application 6W2H...</div>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  // Si utilisateur connecté, afficher les routes
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainApp />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/approvals" element={<ApprovalsPage />} />
        {/* Route par défaut : rediriger vers formulaire principal */}
        <Route path="*" element={<MainApp />} />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;